import {ActionTree, ActionContext} from 'vuex'
import {ISubscriptionStateModel, IRootStateModel} from '../../../interfaces'
import { SubscriptionMutations } from './../mutations'
import { ActionTypes } from './types'
import { MutationTypes } from './../mutations/types'
import {CompanyModel, SubscriptionModel, SubscriptionPlanModel, SubscriptionUpdateModel} from './../../../../services/types'
import { BaseClient } from './../../../../services/client/BaseClient'
import { getClientInstance } from './../../../..//services/client/clientProvider'

type AugmentedActionSubscriptionContext = {
    commit<K extends keyof SubscriptionMutations>(
      key: K,
      payload: Parameters<SubscriptionMutations[K]>[1]
    ): ReturnType<SubscriptionMutations[K]>;
} & Omit<ActionContext<ISubscriptionStateModel, IRootStateModel>, 'commit'>

export interface SubscriptionActions {
    [ActionTypes.SET_SUBSCRIPTION_DATA](context: AugmentedActionSubscriptionContext): Promise<void>;
    [ActionTypes.SET_SUBSCRIPTION_PLANS_LIST](context: AugmentedActionSubscriptionContext): Promise<void>;
    [ActionTypes.SET_SUBSCRIPTION_UPDATE](context: AugmentedActionSubscriptionContext, model: SubscriptionUpdateModel): Promise<void>;
    [ActionTypes.SET_SUBSCRIPTION_DATA_CLEAR](context: AugmentedActionSubscriptionContext): void;
}

export const actions: ActionTree<ISubscriptionStateModel, IRootStateModel> & SubscriptionActions = {
    async [ActionTypes.SET_SUBSCRIPTION_DATA]({commit, getters}) {

        const client: BaseClient = getClientInstance()

        commit(MutationTypes.SET_SUBSCRIPTION_DATA_IS_LOADING, true)        

        try {
            const companyId = (getters.getCompaniesSelectedCompany as CompanyModel).id
            const response: SubscriptionModel = await client.getCompanySubscription(companyId) 

            commit(MutationTypes.SET_SUBSCRIPTION_DATA, response)
        }
        catch(error) {
            console.log('getCompanySubscription', error)
        }
        finally {
            commit(MutationTypes.SET_SUBSCRIPTION_DATA_IS_LOADING, false)
        }
    },
    async [ActionTypes.SET_SUBSCRIPTION_PLANS_LIST]({commit}) {
        const client: BaseClient = getClientInstance()

        commit(MutationTypes.SET_SUBSCRIPTION_DATA_IS_LOADING, true)        

        try {
            const response: SubscriptionPlanModel [] = await client.getPlansList() 

            commit(MutationTypes.SET_SUBSCRIPTION_PLANS_LIST, response)
        }
        catch(error) {
            console.log('getPlansList', error)
        }
        finally {
            commit(MutationTypes.SET_SUBSCRIPTION_DATA_IS_LOADING, false)
        }
    },
    async [ActionTypes.SET_SUBSCRIPTION_UPDATE]({commit, getters}, model: SubscriptionUpdateModel) {
        const client: BaseClient = getClientInstance()

        commit(MutationTypes.SET_SUBSCRIPTION_DATA_IS_LOADING, true)

        try {
            const companyId = (getters.getCompaniesSelectedCompany as CompanyModel).id
            const response: SubscriptionModel = await client.updateCompanySubscription(companyId, model) 

            commit(MutationTypes.SET_SUBSCRIPTION_DATA, response)
        }
        catch(error) {
            console.log('updateCompanySubscription', error)
        }
        finally {
            commit(MutationTypes.SET_SUBSCRIPTION_DATA_IS_LOADING, false)
        }
    },
    [ActionTypes.SET_SUBSCRIPTION_DATA_CLEAR]({commit}) {
        commit(MutationTypes.SET_SUBSCRIPTION_DATA, null)
    }
}